import React, { useRef } from 'react'
import aliOSS from 'ali-oss'
import styles from './index.module.scss'
import request from '../../network/request'

interface IProps {
  children: JSX.Element | string
  disabled?: boolean
  multiple?: boolean
  accept?: string
  beforeUpload: any
  onSuccess?: any
  onError?: any
}
export default function Upload({
  children,
  disabled = false,
  multiple = false,
  accept = 'image/jpeg,image/jpg,image/png',
  beforeUpload,
  onSuccess,
  onError,
}: IProps) {
  const inputRef = useRef<any>(null)

  const handleClick = (event) => {
    if (disabled !== true ) {
      inputRef.current.click()
    }
  }

  const handleChange = (event) => {
    const files = event.target.files

    let funcResult = beforeUpload(files)
    if (funcResult === undefined || funcResult === true) {
      handleRequest(files)
    } else {
      inputRef.current.value = null
    }
  }

  const handleRequest = async (files) => {
    const filesArr = Array.from(files) as any[]

    console.log(filesArr);
    

    if (filesArr?.length === 0) {
      handleError(new Error('请选择文件'))
      return
    }

    const resFileList: any[] = []

    for (let fileIndex = 0; fileIndex < filesArr.length; fileIndex++) {
      const curFileName = filesArr[fileIndex].name

      try {
        const ossToken: any = await request.get(
          '/dragon/service/aliyun/token',
          {
            params: {
              fileName: curFileName,
            },
          }
        )

        if (ossToken) {
          const ossClient = await new aliOSS({
            accessKeyId: ossToken.accessKeyId,
            accessKeySecret: ossToken.accessKeySecret,
            stsToken: ossToken.securityToken,
            region: 'oss-cn-hangzhou',
            bucket: ossToken.bucket,
            secure: true,
          })
          const filePath = ossToken.path
          const fileUrl = ossToken.url

          const uploadRes: any = await ossClient.multipartUpload(
            filePath,
            filesArr[fileIndex]
          )

          if (uploadRes?.res?.statusCode === 200) {
            resFileList.push({
              fileName: curFileName,
              address: fileUrl,
            })
          }
        }
      } catch (err) {
        console.log(err)
      }
    }

    if (resFileList.length > 0) {
      handleSuccess(resFileList)
    } else {
      handleError('上传出错，请重试')
    }

    inputRef.current.value = null
  }

  const handleSuccess = (res) => {
    typeof onSuccess === 'function' && onSuccess(res)
  }

  const handleError = (err) => {
    typeof onError === 'function' && onError(err)
  }

  return (
    <div className={styles.uploadWrap} onClick={handleClick}>
      {children}
      <input
        disabled={disabled}
        multiple={multiple}
        ref={inputRef}
        className={styles.uploadInput}
        type="file"
        accept={accept}
        onChange={handleChange}
      />
    </div>
  )
}
